<template>
  <div class="header">
    푸시 알림 테스트 페이지
    <br/><br/>

    <button @click="getPushToken">토큰가져오기!</button>
    <br/><br/>

    <button @click="sendPush">발송!</button>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'PushTest',
  components: {},
  mixins: [],
  props: {},
  data: () => ({
    token: ''
  }),
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    window.callbackToken = (token) => {
      this.token = token.replace('Optional("', '').replace('")', '')
      this.updateToken(this.token)
    }
  },
  methods: {
    getPushToken () {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('android') >= 0) {
        let token = window.AndroidInterface.getFCMToken()
        this.token = token
        this.updateToken(token)
      }
    },
    async sendPush () {
      await store.dispatch('sendPush', this.$_payload(null, {token: this.token}))
          .then(() => {
            // console.log(res)
          })
          .catch(error => {
            console.error(error)
          })
    },
    async updateToken (token) {
      await store.dispatch('updatePushToken', this.$_payload(null, {token: token}))
          .then(() => {
            // console.log(res)
          })
          .catch(error => {
            console.error(error)
          })
    }
  }
}
</script>

<style scoped>
</style>
